import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getPodcastPage } from "../configureStore";
import { fetchPodcastPage } from "../configureStore/podcastPage";
import { getHelmet } from "../utilities";
import { FromTopPage, GridWrapper, Banner } from "../theme";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import PageLoader from "../components/loader/PageLoader";
import ShowMenu from "../components/menu/ShowMenu";
import ContentList from "../components/content/ContentList";
import Pagination from "../components/Pagination";
import JoinUs from "../components/JoinUs";

const Header = styled(Banner)`
  margin-bottom: 60px;

  @media (max-width: 767px) {
    margin-bottom: 30px;
  }
`;

class Podcast extends Component {
  static fetchInitialData({ slug, page }) {
    return [fetchPodcastPage(slug, page)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { podcastPage, dispatch, match } = this.props;
    if (
      !podcastPage.isFetching &&
      !podcastPage.error &&
      !podcastPage.content.length
    ) {
      dispatch(fetchPodcastPage(match.params.slug, match.params.page));
    }
  }

  render() {
    const podcastPage = this.props.podcastPage;

    if (!podcastPage.nbrPages && podcastPage.error) {
      if (podcastPage.error === "404") {
        return <NotFound />;
      }

      return <Error message={podcastPage.error} />;
    }

    if (!podcastPage.nbrPages) {
      return <PageLoader />;
    }

    return (
      <>
        <Helmet>
          {getHelmet(
            podcastPage.podcast.label,
            podcastPage.podcast.description,
            this.props.location.pathname,
            podcastPage.content.length && podcastPage.content[0].thumb_hero_url
          )}
        </Helmet>
        <ShowMenu category={podcastPage.podcast} />
        <FromTopPage>
          <Header>
            <GridWrapper>
              <div>
                <h1>{podcastPage.podcast.label}</h1>
                <p>{podcastPage.podcast.description}</p>
              </div>
            </GridWrapper>
          </Header>
          <Pagination nbrPages={podcastPage.nbrPages} />
          <ContentList
            contentList={podcastPage}
            constrainedSchemeItem="AUDIO"
          />
          <Pagination nbrPages={podcastPage.nbrPages} />
          <JoinUs />
        </FromTopPage>
      </>
    );
  }
}

Podcast.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
      page: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  podcastPage: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
    podcast: PropTypes.shape({
      label: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
    nbrPages: PropTypes.number,
    content: PropTypes.array.isRequired,
  }).isRequired,
};

export default connect((state, { match }) => ({
  podcastPage: getPodcastPage(state, match.params.slug, match.params.page),
}))(Podcast);
